import { func } from 'prop-types';
import React from 'react';

import ContentColumns from '../../components/ContentColumns';

const View1 = (_, { fm }) => {
  return (
    <React.Fragment>
      <ContentColumns
        firstColumn={
          <div>
            <h2>{fm('onlineRehabilitation.rehab7.1.welcome')}</h2>
            <br />
            <div>{fm('onlineRehabilitation.rehab7.1.text')}</div>
            <br />
          </div>
        }
      />
    </React.Fragment>
  );
};

View1.contextTypes = {
  fm: func,
};

export default View1;
